module.exports = __webpack_public_path__ + "arrow.089b316c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/arrow.svg
 ** module id = 244
 ** module chunks = 0
 **/